<template class="full-height">
  <div class="member-container full-height">
    <!-- 發文 -->
    <el-dialog
      @closed="onDialogArticleClosed"
      :title="formData.id ? '編輯資料' : '新增資料'"
      :visible.sync="dialogFormVisible"
      top="2%"
      width="90%"
    >
      <el-form ref="ArticleValidateForm" v-loading="formLoading" :model="formData">
        <el-form-item label="封面照" :label-width="formLabelWidth">
          <div>
            <Upload
              ref="uploadArticleRef"
              :accept="'.jpg,.jpeg,.png'"
              :payload="formData"
              :data-obj="fileObj"
              :limitText="'圖片尺寸:840x480，須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
              :limit-file-count="3"
              :use-drag="false"
              :action="'ToursCombine/saveArticle'"
              :auto-upload="false"
              :show-file-list="true"
              :form-on-loading-parent="formLoading"
              :btn-txt="'上傳'"
              :before-file-list="
                formData.fileInfo && formData.fileInfo.length ? formData.fileInfo[0].files : []
              "
            />
          </div>
        </el-form-item>

        <el-form-item
          label="影片連結"
          :label-width="formLabelWidth"
          prop="externalLink"
          :rules="[{ validator: validateLink, trigger: 'blur' }]"
        >
          <el-input
            v-model="formData.externalLink"
            autocomplete="off"
            placeholder="若有輸入影片連結，則封面會以影片優先顯示"
          />
        </el-form-item>

        <el-form-item
          label="標題"
          :label-width="formLabelWidth"
          prop="title"
          :rules="[{ required: true, message: '請輸入標題', trigger: 'blur' }]"
        >
          <el-input v-model="formData.title" autocomplete="off" maxlength="100" show-word-limit />
        </el-form-item>

        <el-form-item
          label="國家"
          :label-width="formLabelWidth"
          prop="country"
          :rules="[
            { type: 'array', message: '型別錯誤', trigger: 'blur' },
            { required: true, message: '請選擇國家', trigger: 'blur' },
          ]"
        >
          <el-cascader
            v-model="formData.country"
            :options="cascaderCountryOptions"
            style="width: 100%"
            :props="{
              multiple: true,
              value: 'id',
            }"
            collapse-tags
          ></el-cascader>
        </el-form-item>

        <el-form-item
          label="項目及分類"
          :label-width="formLabelWidth"
          prop="itemType"
          :rules="[
            { type: 'array', message: '型別錯誤', trigger: 'blur' },
            { required: true, message: '請選擇項目及分類', trigger: 'blur' },
          ]"
        >
          <el-cascader
            v-model="formData.itemType"
            :options="cascaderOptions"
            style="width: 100%"
            :props="{
              multiple: true,
              value: 'id',
              label: 'title',
              children: 'types',
            }"
            collapse-tags
          ></el-cascader>
        </el-form-item>

        <el-form-item label="內容" :label-width="formLabelWidth" prop="articleContent">
          <div>
            <tinymce ref="tinymce" v-model="formData.articleContent" :height="300" :type="16" />
          </div>
        </el-form-item>

        <el-form-item
          label="發文者"
          :label-width="formLabelWidth"
          prop="BuildUserID"
          :rules="[{ required: true, message: '請輸入標題', trigger: 'blur' }]"
        >
          <el-select v-model="formData.BuildUserID" placeholder="請選擇作者" style="width: 100%">
            <el-option
              v-for="item in authorList"
              :key="item.id"
              :label="item.authorName"
              :value="item.bindUser"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item
          label="發文日期"
          :label-width="formLabelWidth"
          prop="buildDate"
          :rules="[
            {
              required: true,
              message: '請選擇發文日期',
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="formData.buildDate"
            type="date"
            placeholder="請選擇發文日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item> -->

        <el-form-item
          label="發文日期"
          :label-width="formLabelWidth"
          prop="buildDate"
          :rules="[
            {
              required: true,
              message: '請選擇發文日期',
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="formData.buildDate"
            type="datetime"
            placeholder="請選擇發文日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          label="hashTags"
          :label-width="formLabelWidth"
          prop="hashtags"
          :rules="[{ type: 'array', message: '型別錯誤', trigger: 'blur' }]"
        >
          <el-select
            v-model="formData.hashtags"
            multiple
            filterable
            remote
            reserve-keyword
            allow-create
            placeholder="請輸入關鍵字"
            :remote-method="remoteMethod"
            :loading="loading"
            :no-data-text="'無資料'"
            value-key="id"
            style="width: 100%"
          >
            <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="排序"
          :label-width="formLabelWidth"
          prop="sort"
          :rules="[
            {
              required: true,
              message: '請輸入排序',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="formData.sort" autocomplete="off" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onDialogArticleClosed">取 消</el-button>
        <el-button type="primary" @click="saveData('ArticleValidateForm')">儲 存</el-button>
      </div>
    </el-dialog>

    <!-- 編輯簡介 -->
    <el-dialog
      :top="dialogTopMargin"
      v-loading="listLoading"
      :visible.sync="dialogIntroFormVisible"
      :title="roleSettingObj.id ? '編輯簡介' : '新增簡介'"
      @closed="onDialogClosed"
    >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-alert
            :closable="false"
            title="此為向外公開的個人簡介資料"
            type="warning"
            effect="dark"
          >
          </el-alert>
        </div>
        <el-form
          :rules="introRules"
          size="mini"
          ref="introductionForm"
          :model="roleSettingObj"
          :label-width="formLabelWidth"
        >
          <el-form-item label="頭貼" :label-width="formLabelWidth">
            <div>
              <span>尺寸:70*70</span>
              <Upload
                ref="uploadRef"
                :accept="'.jpg,.jpeg,.png'"
                :payload="roleSettingObj"
                :limit-file-count="1"
                :data-obj="fileObj"
                :use-drag="false"
                :action="'ToursCombine/saveIntroAvatar'"
                :auto-upload="false"
                :show-file-list="true"
                :form-on-loading-parent="listLoading"
                :btn-txt="'上傳'"
                :before-file-list="
                  roleSettingObj.fileInfo && roleSettingObj.fileInfo.length
                    ? roleSettingObj.fileInfo[0].files
                    : []
                "
              />
            </div>
          </el-form-item>

          <el-form-item :label="'名稱'" prop="authorName">
            <el-input v-model="roleSettingObj.authorName" maxlength="50"></el-input>
          </el-form-item>

          <el-form-item :label="'簡介'" prop="introduction">
            <el-input
              type="textarea"
              v-model="roleSettingObj.introduction"
              :autosize="{ minRows: 4, maxRows: 4 }"
            ></el-input>
          </el-form-item>

          <el-form-item :label="'排序'" prop="sort">
            <el-input v-model="roleSettingObj.sort"></el-input>
          </el-form-item>

          <el-form-item
            v-for="(social, index) in roleSettingObj.socialLinkList"
            :label="'社群' + index"
            :key="index"
          >
            <el-select v-model="social.socialType" placeholder="請選擇">
              <el-option
                v-for="item in socialLinkSelectList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input v-model="social.url" style="width: 50%"></el-input>
            <el-button @click.prevent="removeSocialLink(social)">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="addSocialLink">新增社群</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveIntroduction('introductionForm')">確定</el-button>
        <el-button type="danger" @click="onDialogClosed">取消</el-button>
      </span>
    </el-dialog>

    <!-- 查看證照 -->
    <el-dialog
      v-loading="listLoading"
      :visible.sync="dialogPictureFormVisible"
      title="編輯證照"
      @closed="onPictureDialogClosed"
      :top="'2%'"
    >
      <el-card class="box-card">
        <el-form :model="pictureData">
          <el-form-item label="證照" :label-width="formLabelWidth">
            <div>
              <span>尺寸:840*480</span>
              <Upload
                ref="uploadLRef"
                :accept="'.jpg,.jpeg,.png'"
                :payload="pictureData"
                :data-obj="fileObj"
                :limit-file-count="5"
                :use-drag="false"
                :action="'ToursCombine/saveLeaderProfile'"
                :auto-upload="false"
                :show-file-list="true"
                :form-on-loading-parent="listLoading"
                :btn-txt="'上傳'"
                :before-file-list="pictureData && pictureData.length ? pictureData[0].files : []"
              />
            </div>
          </el-form-item>
        </el-form>
        <template v-if="pictureData && pictureData.length">
          <template v-for="(item, index) in pictureData[0].files">
            <span :key="index">{{ item.fileName }}</span>
            <img
              :key="index"
              width="100%"
              :src="item.url"
              alt=""
              style="margin-top: 10px; margin-bottom: 20px"
            />
          </template>
        </template>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePicture">確定</el-button>
        <el-button type="danger" @click="onPictureDialogClosed">取消</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0" class="full-height">
      <div style="padding-bottom: 0">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="搜尋">
            <el-input
              size="mini"
              v-model="listQuery.qry"
              placeholder="輸入查詢名稱"
              @keyup.enter.native="handleFilter"
            />
          </el-form-item>

          <el-form-item>
            <el-button
              size="mini"
              class="filter-item"
              type="primary"
              icon="el-icon-search"
              @click="handleFilter"
            >
              搜尋
            </el-button>
            <el-button type="success" size="mini" @click="addData">建立文章</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div style="position: relative; height: 80%">
        <el-table
          :key="tableKey"
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          height="100%"
          @sort-change="sortChange"
        >
          <el-table-column :label="'ID'" prop="id" sortable="custom" align="center" width="80">
            <template slot-scope="{ row }">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="頭貼" width="100">
            <template slot-scope="scope">
              <el-image
                style="height: 50px"
                :src="
                  scope.row.fileInfo.length > 0
                    ? scope.row.fileInfo[0].files[0].url
                    : 'https://fakeimg.pl/70/'
                "
                fit="contain"
                :preview-src-list="
                  scope.row.fileInfo.length > 0
                    ? [scope.row.fileInfo[0].files[0].url]
                    : ['https://fakeimg.pl/70/']
                "
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column
            :label="'帳號'"
            prop="account"
            sortable="custom"
            align="left"
            width="130"
          >
            <template slot-scope="{ row }">
              <span>{{ row.account }}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="'角色'"
            prop="roles"
            sortable="custom"
            align="center"
            width="130"
          >
            <template slot-scope="{ row }">
              <span>{{ row.roles.toString() }}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="'名稱'"
            prop="authorName"
            sortable="custom"
            align="left"
            width="130"
          >
            <template slot-scope="{ row }">
              <a :href="openUrl + '/' + row.code" target="_blank">
                <span style="color: rgb(64, 158, 255)">{{ row.authorName }}</span>
              </a>
            </template>
          </el-table-column>

          <el-table-column
            :label="'簡介'"
            prop="introduction"
            sortable="custom"
            align="center"
            width="200"
          >
            <template slot-scope="{ row }">
              <span>{{ row.introduction }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'排序'" prop="sort" sortable="custom" align="center" width="130">
            <template slot-scope="{ row }">
              <span>{{ row.sort }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="title == 'TCLeader'" align="center" label="資格審核" width="150">
            <template slot-scope="scope">
              <i
                v-if="scope.row.manuallyValidated == false"
                class="el-icon-circle-close"
                style="font-size: 28px; color: red"
              ></i>
              <i v-else class="el-icon-circle-check" style="font-size: 28px"></i>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'操作'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="primary"
                icon="el-icon-edit"
                @click="editIntroductionInfo(scope.row)"
              >
                編輯簡介
              </el-button>
            </template>
          </el-table-column>

          <el-table-column v-if="title == 'TCLeader'" align="center" :label="'操作'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="success"
                icon="el-icon-edit"
                @click="viewPicture(scope.row)"
              >
                編輯證照
              </el-button>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'刪除'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="danger"
                icon="el-icon-delete"
                @click="deleteIntro(scope.row)"
              >
                刪除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        style="padding-top: 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // secondary package based on el-pagination
import Upload from '@/views/ita/components/fileUpload.vue'
import checkPermission from '@/utils/permission' // 权限判断函数
import Tinymce from '@/components/Tinymce'
import { Message } from 'element-ui'

import {
  deleteIntroduction,
  getArticleIntroductionList,
  getHashTagList,
  getIntroductionList,
  getIntroductionTypeList,
  getItemOfType,
  getLeaderLicense,
  saveArticle,
  saveHashTagFromArticle,
  saveIntroduction,
  saveLeaderLicense,
} from '@/api/tcSetting'
import { getTravelAttractionsCascaderMenu } from '@/api/travel'
import { dateFullFormat } from '@/utils'
import { convertFileToBase64 } from '@/utils/funcs'

var defaultForm = {
  id: null,
  fileInfo: [], //封面照-可多張圖片
  contentfileInfo: [],
  title: '',
  itemType: [], //項目及分類
  externalLink: '', //影片連結，有設定則封面照為影片
  hashtags: [],
  articleContent: '', //編輯器內容
  sort: 99,
  country: [],
  //buildDate: new Date(),
  BuildUserID: null,
  buildDate: dateFullFormat(new Date()),
}

var defaultIntroductionFormData = {
  id: null,
  authorName: '',
  introduction: '',
  sort: 99,
  socialLinkList: [],
  fileInfo: [],
}
export default {
  name: 'Member',
  components: { Pagination, Upload, Tinymce },
  directives: { waves },
  filters: {},
  props: {
    pageRoles: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    var validateLink = (rule, value, callback) => {
      if (value == '') {
        callback()
      } else if (value.includes('https://www.youtube.com/watch?')) {
        callback(new Error('請貼上正確的連結'))
      } else if (!value.includes('https://youtu.be/')) {
        callback(new Error('請貼上正確的連結'))
      } else {
        callback()
      }
    }
    return {
      validateLink: validateLink,
      introRules: {
        authorName: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        introduction: [{ required: true, message: '請輸入簡介', trigger: 'blur' }],
      },
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      showPwdInupt: false,
      funcName: '帳號管理',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      dialogMemberFormVisible: false,
      roleSettingObj: {},
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        roles: this.pageRoles,
        page: 1,
        limit: 30,
        sort: '+Sort',
      },
      dialogIntroFormVisible: false,
      socialLinkSelectList: [],
      selectedUser: null,
      openUrl: '',
      formData: defaultForm,
      dialogFormVisible: false,
      options: [],
      loading: false,
      cascaderOptions: [],
      cascaderCountryOptions: [],
      formLoading: false,
      authorList: [],
      dialogPictureFormVisible: false,
      pictureData: {},
      currentUserID: null,
    }
  },
  async created() {
    await this.getIntroSelectType()
    await this.getList()
    await this.getItemType()
    await this.getTravelCountryCascaderMenu()
    this.openUrl = process.env.VUE_APP_BASE_AUTHOR
  },
  methods: {
    async getIntroSelectType() {
      await getIntroductionTypeList()
        .then(response => {
          this.socialLinkSelectList = response
        })
        .catch(error => {
          console.log(error)
        })
    },
    loadingHanlder(action) {
      let vm = this
      if (vm.listLoading != action) {
        vm.listLoading = action
      }
    },
    checkPermission,

    async deleteIntro(row) {
      let vm = this
      if (confirm(`確定刪除【${row.authorName}】?\r\n`)) {
        vm.loadingHanlder(true)
        let resp = await deleteIntroduction({ id: row.id })
        if (resp.success) {
          await vm.getList()
          this.$message({
            message: '操作成功',
            type: 'success',
          })
        }
        vm.loadingHanlder(false)
      }
    },
    async editIntroductionInfo(row) {
      let vm = this
      vm.selectedUser = row.id
      vm.roleSettingObj = JSON.parse(JSON.stringify(row))
      vm.dialogIntroFormVisible = true
    },
    saveIntroduction(formName) {
      if (!confirm('確定儲存資料?')) {
        return
      }
      let vm = this
      let refUpload = this.$refs['uploadRef']
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            this.$message.error('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }
          // 編輯既有資料且未重選檔案時，combineFileAndPayload 不會 push fileModel
          // (fileUpload.vue:451)，payload.fileInfo 維持空陣列，直接取 [0] 會 TypeError；
          // 又因位於 validate 的 async callback 內被吞成 unhandled rejection，
          // 畫面上就是「按儲存完全沒反應」。改判斷「新檔或舊檔至少一張」。
          // 另濾除無效的舊檔 ID，避免空值被當成「有舊圖」而誤放行。
          const oldIDs = (payload.fileIDs || []).filter(
            id => id !== undefined && id !== null && id !== ''
          )
          payload.fileIDs = oldIDs
          const hasNewFile = payload.fileInfo && payload.fileInfo.length > 0
          if (!hasNewFile && oldIDs.length === 0) {
            this.$message.error('請上傳大頭貼')
            return false
          }
          vm.loadingHanlder(true)
          payload.bindUser = vm.selectedUser
          await saveIntroduction(payload)
            .then(async response => {
              vm.onDialogClosed()
              await vm.getList()
              vm.loadingHanlder(false)
              this.$message({
                message: '操作成功',
                type: 'success',
              })
            })
            .catch(error => {})
        }
      })
    },
    addSocialLink() {
      this.roleSettingObj.socialLinkList.push({
        id: null,
        socialType: 1,
        url: '',
      })
    },
    removeSocialLink(item) {
      var index = this.roleSettingObj.socialLinkList.indexOf(item)
      if (index !== -1) {
        this.roleSettingObj.socialLinkList.splice(index, 1)
      }
    },
    async viewPicture(row) {
      console.log(row)
      this.loadingHanlder(true)
      await getLeaderLicense({ id: row.bindUser })
        .then(response => {
          console.log(response)
          this.pictureData = response.data
          this.dialogPictureFormVisible = true
          this.currentUserID = row.bindUser
          this.loadingHanlder(false)
        })
        .catch()
    },
    async savePicture() {
      if (!confirm('確定儲存資料?')) {
        return
      }
      let vm = this
      let refUpload = this.$refs['uploadLRef']
      let payload = await refUpload.combineFileAndPayload()
      if (!payload) {
        alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
        return false
      }
      vm.loadingHanlder(true)
      await saveLeaderLicense({
        userId: this.currentUserID,
        fileIDs: payload.fileIDs,
        fileInfo: payload.fileInfo,
      })
        .then(response => {
          vm.loadingHanlder(false)
          vm.onPictureDialogClosed()
          this.$message({
            message: '操作成功',
            type: 'success',
          })
        })
        .catch()
    },
    onPictureDialogClosed() {
      let refUpload = this.$refs['uploadLRef']
      refUpload.clearFiles()
      this.dialogPictureFormVisible = false
    },
    async getList() {
      this.loadingHanlder(true)
      var res = await getIntroductionList(this.listQuery)
      this.list = res.data.data
      this.total = res.data.totalItemCount
      this.loadingHanlder(false)
    },
    onDialogClosed() {
      let refUpload = this.$refs['uploadRef']
      refUpload.clearFiles()
      this.$refs['introductionForm'].clearValidate()
      this.roleSettingObj = JSON.parse(JSON.stringify(defaultIntroductionFormData))
      this.dialogIntroFormVisible = false
    },
    onDialogArticleClosed() {
      let refUpload = this.$refs['uploadArticleRef']
      refUpload.clearFiles()
      this.$refs['ArticleValidateForm'].clearValidate()
      this.formData = JSON.parse(JSON.stringify(defaultForm))
      this.$refs['tinymce'].setValue('') //重置內容
      this.dialogFormVisible = false
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.status = status
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(async () => {
          await getHashTagList({ query: query })
            .then(response => {
              this.loading = false
              this.options = response.data
            })
            .catch(error => {
              console.log(error)
            })
        }, 800)
      } else {
        this.options = []
      }
    },
    async getItemType() {
      await getItemOfType().then(response => {
        this.cascaderOptions = response.data
      })
    },
    async getTravelCountryCascaderMenu() {
      await getTravelAttractionsCascaderMenu().then(response => {
        this.cascaderCountryOptions = response.data
      })
    },
    async addData() {
      const vm = this
      vm.formData = JSON.parse(JSON.stringify(defaultForm))
      vm.formData.buildDate = new Date()
      await getArticleIntroductionList({ roles: this.pageRoles })
        .then(response => {
          this.authorList = response.data
          vm.dialogFormVisible = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    async saveData(formName) {
      const vm = this
      if (!confirm(`確定要儲存該筆資料?`)) {
        return false
      }
      //$refs["uploadRef"] 不能放在 $refs[formName]的敘述裡面建立，組件裡面會找不到refs.upload
      let refUpload = this.$refs['uploadArticleRef']
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            this.$message.error('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }
          // 編輯既有資料且未重選檔案時，combineFileAndPayload 不會 push fileModel
          // (fileUpload.vue:451)，payload.fileInfo 維持空陣列，直接取 [0] 會 TypeError；
          // 又因位於 validate 的 async callback 內被吞成 unhandled rejection，
          // 畫面上就是「按儲存完全沒反應」。改判斷「新檔或舊檔至少一張」。
          // 另濾除無效的舊檔 ID，避免空值被當成「有舊圖」而誤放行。
          const oldIDs = (payload.fileIDs || []).filter(
            id => id !== undefined && id !== null && id !== ''
          )
          payload.fileIDs = oldIDs
          const hasNewFile = payload.fileInfo && payload.fileInfo.length > 0
          if (!hasNewFile && oldIDs.length === 0 && payload.externalLink == '') {
            this.$message.error('請上傳文章封面照')
            return false
          }
          vm.formLoading = true
          var newHashTag = payload.hashtags.filter(x => {
            return typeof x == 'string'
          })
          if (newHashTag.length) {
            await saveHashTagFromArticle(newHashTag)
              .then(async response => {
                var HashTag = payload.hashtags.filter(x => {
                  return typeof x !== 'string'
                })
                HashTag = HashTag.concat(response.data)
                payload.hashtags = HashTag
              })
              .catch(error => {
                console.log(error)
              })
          }
          payload.contentfileInfo = []
          //儲存內文變成檔案
          if (payload.articleContent !== '') {
            const fileContent = new File([payload.articleContent], 'articleContent.txt', {
              type: 'text/plain',
            })
            const contentFileModel = {
              type: 34,
              files: [],
            }
            await convertFileToBase64(fileContent).then((resolve, reject) => {
              contentFileModel.files.push({
                fileName: 'articleContent.txt',
                base64: resolve,
              })
              payload.contentfileInfo.push(contentFileModel)
            })
          }
          payload.buildDate = dateFullFormat(payload.buildDate)
          await saveArticle(payload)
            .then(res => {
              vm.onDialogArticleClosed()
              vm.formLoading = false
              Message({
                message: '資料處理完成',
                type: 'success',
                duration: 5 * 1000,
              })
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    sortChange(data) {
      const { prop, order } = data
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
  },
}
</script>
<style scope>
.full-height {
  position: relative;
  height: 100%;
}
</style>
